// API base URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// Auth endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
};

// User endpoints
export const USER_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/users/login`,
  REGISTER: `${API_BASE_URL}/users/register`,
  PROFILE: `${API_BASE_URL}/users/profile`,
  UPDATE: `${API_BASE_URL}/users/update`,
  WEBHOOKS: `${API_BASE_URL}/users/webhooks`,
  WEBHOOK: (id) => `${API_BASE_URL}/users/webhooks/${id}`,
};

// Flight endpoints
export const FLIGHT_ENDPOINTS = {
  LIST: `${API_BASE_URL}/flights`,
  CREATE: `${API_BASE_URL}/flights`,
  DETAIL: (id) => `${API_BASE_URL}/flights/${id}`,
  HISTORY: (id) => `${API_BASE_URL}/flights/${id}/priceHistory`,
  TOGGLE: (id) => `${API_BASE_URL}/flights/${id}/toggle`
};

// Webhook endpoints
export const WEBHOOK_ENDPOINTS = {
  LIST: `${API_BASE_URL}/users/webhooks`,
  CREATE: `${API_BASE_URL}/users/webhooks`,
  DETAIL: (id) => `${API_BASE_URL}/users/webhooks/${id}`,
  TELEGRAM_URL: (apiKey) => `${API_BASE_URL}/getTelegramUrl?apiKey=${apiKey}`,
};

// Admin endpoints
export const ADMIN_ENDPOINTS = {
  LIST: `${API_BASE_URL}/admin/users`,
  DETAIL: (id) => `${API_BASE_URL}/admin/users/${id}`,
  UPDATE: (id) => `${API_BASE_URL}/admin/users/${id}`,
  CREATE: `${API_BASE_URL}/admin/users`,
};

// Default headers
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

// Helper function to add auth token to headers
export const getAuthHeaders = (token) => {
  return {
    ...DEFAULT_HEADERS,
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
}; 